export const MODERATOR_STATUS = {
  ACTIVE: "active",
  SUSPEND: "inactive",
};

export const STATUS_FILTER = [
  { label: "Status", value: "All" },
  { label: "Resolved", value: "resolved" },
  { label: "Dismissed", value: "dismissed", width: "110px" },
];

export const REPORT_REASON_FILTER = [
  { label: "Report Reason", value: "All" },
  {
    label: "Inappropriate Content",
    value: "inappropriate_content",
    width: "180px",
  },
  { label: "Spam", value: "spam" },
  { label: "Harassment", value: "harassment" },
  { label: "Other", value: "other" },
];

export const CONTENT_TYPE_FILTER = [
  { label: "Content Type", value: "All" },
  { label: "Activity", value: "activity" },
  { label: "Chat", value: "activity_message" },
  { label: "Profile", value: "user" },
];

export const ROLE_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "moderator", label: "Moderator" },
];
